export enum QUERY_KEYS {
  GET_PROFILE = 'getProfile',
  GET_COMPANIES = 'getCompanies',
  GET_COMPANIES_DATA = 'getCompaniesData',
  GET_ALL_COMPANIES = 'getAllCompanies',
  GET_COMPANY_BY_ID = 'getCompanyById',
  GET_USER = 'getUsers',
  GET_USER_DATA = 'getUsersData',
  GET_USER_ID = 'getUserById',
  GET_USER_NAMES = 'getUsersNames',
  GET_ADMIN_NAMES = 'getAdminNames',
  GET_ASSOCIATE_LEVEL_BY_ID = 'getAssociateLevelById',
  GET_ALL_REQUESTS = 'getAllRequests',
  GET_REJECTED_USER = 'getRejectedUsers',
  GET_MY_TEAM = 'getMyTeam',
  GET_MY_TEAM_HEAD = 'getMyTeamHead',
  GET_ALL_TEAM = 'getAllTeam',
  GET_ALL_TEAM_HEAD = 'getAllTeamHead',
  GET_ADMIN = 'getAdmins',
  GET_ADMIN_DATA = 'getAdminData',
  GET_ADMIN_ID = 'getAdminById',
  GET_FOLLOWUP = 'getFollowup',
  GET_FOLLOWUP_DATA = 'getFollowupData',
  GET_FOLLOWUP_ID = 'getFollowupById',
  GET_HIGHWAY = 'getHighway',
  GET_HIGHWAY_DATA = 'getHighwaysData',
  GET_HIGHWAY_ID = 'getHighwayById',
  GET_ALL_HIGHWAYS = 'getAllHighways',
  GET_PROJECTS_BY_HIGHWAY_ID = 'getProjectsByHighwayId',
  GET_HIGHWAY_PROJECTS = 'getHighwayProjects',
  GET_ALL_PROJECTS = 'getAllProjects',
  GET_ACTIVE_PROJECTS = 'getActiveProjects',
  GET_PROJECT_DATA = 'getProjectsData',
  GET_PROJECT_BY_ID = 'getProjectById',
  GET_PROJECT_PRICE_BY_ID = 'getProjectPriceById',
  GET_PHASES = 'getPhases',
  GET_PHASES_DATA = 'getPhasesData',
  GET_PHASE_ID = 'getPhaseById',
  GET_PHASE_BY_PROJECT_ID = 'getPhaseByProjectId',
  GET_PLOTS = 'getPlots',
  GET_PLOTS_DATA = 'getPlotsData',
  GET_PLOT_ID = 'getPlotById',
  GET_NOTES = 'getNotes',
  GET_NOTES_DATA = 'getNotesData',
  GET_NOTE_ID = 'getNoteById',
  GET_WEEKLY_NOTES = 'getWeeklyNotes',
  GET_MONTHLY_NOTES = 'getMonthlyNotes',
  GET_GREETINGS = 'getGreetings',
  GET_GREETINGS_DATA = 'getGreetingsData',
  GET_LATEST_GREETING_CATEGORY = 'getLatestGreetingCategory',
  GET_INACTIVE_GREETINGS_DATA = 'getInactiveGreetingsData',
  GET_LEADS = 'getLeads',
  GET_LEADS_DATA = 'getLeadsData',
  GET_LEADS_LIST = 'getLeadsList',
  GET_PENDING_LEADS = 'getPendingLeads',
  GET_LEAD_ID = 'getLeadById',
  GET_PAYMENTS = 'getPayments',
  GET_PAYMENTS_DATA = 'getPaymentsData',
  GET_PAYMENT_BY_ID = 'getPaymentById',
  GET_PAYMENT_BY_PROJECT_NAME = 'getPaymentsByProjectName',
  GET_REMINDERS = 'getReminders',
  GET_REMINDERS_DATA = 'getRemindersData',
  GET_TODAYS_REMINDERS = 'getTodaysReminders',
  GET_REMINDER_BY_ID = 'getReminderById',
  GET_SITEVISITS = 'getSitevisits',
  GET_SITEVISITS_DATA = 'getSitevisitsData',
  GET_TODAY_SITEVISITS = 'getTodaysSitevisits',
  GET_SITEVISIT_BY_ID = 'getSitevisitById',
  GET_NEWS = 'getNews',
  GET_NEWS_DATA = 'getNewsData',
  GET_TODAY_NEWS = 'getTodaysNews',
  GET_NEWS_BY_ID = 'getNewsById',
  GET_TOP_DAILY_NEWS = 'getTopDailyNews',
  GET_DAILY_NEWS_DATA = 'getDailyNewsData',
  GET_DAILY_NEWS_BY_ID = 'getDailyNewsById',
  GET_ROLES = 'getRoles',
  GET_ALL_ROLES = 'getAllRoles',
  GET_MY_ROLE = 'getMyRole',
  GET_ROLE_BY_ID = 'getRoleById',
  GET_VIDEO = 'getVideos',
  GET_VIDEOS_DATA = 'getVideosData',
  GET_ALL_VIDEOS = 'getAllVideos',
  GET_VIDEO_BY_ID = 'getVideoById',
  FETCH_USERS_REPORT = 'fetchReportUsers',
  FETCH_PLOTS_REPORT = 'fetchReportPlots',
  FETCH_COMPANY_REPORT = 'fetchReportCompany',
  GET_DASHBOARD = 'getDashboard',
  GET_ASSOCIATE_DASHBOARD = 'getAssociateDashboard',
  GET_TEAM_TREE = 'getTeamTree',
  GET_PLOTS_BOOKING_COUNT = 'getPlotsBookingCount',
  GET_NOTIFICATIONS = 'getNotifications',
  GET_NOTIFICATIONS_COUNT = 'getNotificationsCount',
  GET_NOTIFICATIONS_READ = 'getNotificationsRead',
  GET_NOTIFICATIONS_UNREAD = 'getNotificationsUnread',
  GET_MODULES = 'getModules',
  GET_COMPANY_MODULES = 'getCompanyModules',
  GET_ASSOCIATE_CONTRIBUTION_DATA = 'getAssociateContributionData',
  GET_ASSOCIATE_CONTRIBUTION_BY_ID = 'getAssociateContributionById',
  GET_ASSOCIATE_CONTRIBUTION_BY_EMPLOYEE_ID = 'getAssociateContributionByEmployeeId',
  GET_ASSOCIATE_EXPENSE_DATA = 'getAssociateExpenseData',
  GET_ASSOCIATE_EXPENSE_BY_ID = 'getAssociateExpenseById',
  GET_ASSOCIATE_EXPENSE_BY_EMPLOYEE_ID = 'getAssociateExpenseByEmployeeId',
  GET_ASSOCIATE_FINANCIAL_SUMMARY = 'getAssociateFinancialSummary',
  GET_TEAM_FINANCIAL_SUMMARY = 'getTeamFinancialSummary',
  GET_VEHICLE_SITEVISIT_DATA = 'getVehicleSitevisitData',
  GET_VEHICLE_SITEVISIT_BY_ID = 'getVehicleSitevisitById',
  GET_VEHICLE_SITEVISIT_BY_EMPLOYEE_ID = 'getVehicleSitevisitByEmployeeId',
  GET_SHOWCASES = 'getShowcases',
  GET_SHOWCASES_DATA = 'getShowcasesData',
  GET_LATEST_POPUPS = 'getLatestPopups',
  GET_SLIDERS = 'getSliders',
  GET_PORTRAIT_VIDEOS = 'getPortraitVideos',
  GET_PORTRAIT_VIDEOS_DATA = 'getPortraitVideosData',
  GET_PORTRAIT_VIDEO_BY_ID = 'getPortraitVideoById',
  GET_PROJECT_INCENTIVES = 'getProjectIncentives',
  GET_PROJECT_INCENTIVE_BY_ID = 'getProjectIncentiveById',
  GET_PROJECT_INCENTIVE_BY_PROJECT_ID = 'getProjectIncentiveByProjectId',
  GET_BANK_DATA = 'getBankData',
  GET_BANK_BY_ID = 'getBankById',
  GET_BANK_NAMES = 'getBankNames',
  GET_CHEQUE_SERIES = 'getChequeSeriesData',
  GET_CHEQUE_SERIES_BY_ID = 'getChequeSeriesById',
  GET_ACCOUNT_TREE_DATA = 'getAccountTreeData',
  GET_ACCOUNT_TREE = 'getAccountTree',
  GET_ACCOUNT_TREE_BY_ID = 'getAccountTreeById',
  GET_ACCOUNT_TREE_NAMES = 'getAccountTreeNames',
  GET_LEDGER_DATA = 'getLedgerData',
  GET_LEDGER_BY_ID = 'getLedgerById',
  GET_LEDGER_NAMES = 'getLedgerNames',
  GET_SUBLEDGER_DATA = 'getSubLedgerData',
  GET_SUBLEDGER_BY_ID = 'getSubLedgerById',
  GET_SUBLEDGER_NAMES_BY_LEDGER_ID = 'getSubLedgerNamesByLedgerId',
  GET_FINANCE_LOGS = 'getFinanceAuditLogs',
  GET_FINANCE_LOGS_DATA = 'getFinanceAuditLogsData',
  GET_FINANCE_LOGS_BY_ID = 'getFinanceAuditLogById',
  GET_TRANSACTIONS_DATA = 'getTransactionsData',
  GET_GENERAL_RECEIPTS_DATA = 'getGeneralReceiptsData',
  GET_GENERAL_RECEIPTS_BY_ID = 'getGeneralReceiptById',
  GET_PAYMENT_VOUCHERS_DATA = 'getPaymentVouchersData',
  GET_PAYMENT_VOUCHERS_BY_ID = 'getPaymentVoucherById',
  GET_JOURNAL_VOUCHERS_DATA = 'getJournalVouchersData',
  GET_JOURNAL_VOUCHERS_BY_ID = 'getJournalVoucherById',
  GET_CHEQUE_LIST = 'getChequesListData',
  GET_CHEQUE_SUMMARY = 'getChequeSummary',
  GET_PARTY_DATA = 'getPartyData',
  GET_PARTY_BY_ID = 'getPartyById',
  GET_PARTY_NAMES = 'getPartyNames',
  GET_PARTY_BANK_DETAILS_BY_ID = 'getgetPartyBankDetailsByPartyId',
  GET_CASH_BOOK_DATA = 'getCashBookData',
  GET_BOOKING_REQUESTS = 'getBookingRequests',
}
